import { createFileRoute } from "@tanstack/react-router";

import PresenterControlPage from "~/pages/gameSession/PresenterControlPage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/score-taking/presenter")({
    component: PresenterControlPage,
});
